export const iconFontAwesomeWeatherHouseTsunami = (
	<i className="fa-solid fa-house-tsunami"></i>
);
